import React, {Fragment} from "react";
import PropTypes from "prop-types";

const Grade = (props) => {
  return (
    <Fragment>
      <select className="grades" name="grade" onChange = {props.computeGrades}>
        <option value="-">-</option>
        <option value="4.00">A</option>
        <option value="3.50">B+</option>
        <option value="3.00">B</option>
        <option value="2.50">C+</option>
        <option value="2.00">C</option>
        <option value="1.00">D</option>
        <option value="0.00">F</option>
        <option value="0.00">W</option>
      </select>
    </Fragment>
  );
};

Grade.propTypes = {};

export default Grade;
